import {
    IBoardUserMetasActionSetAction,
    USER_BOARD_METAS_ACTION_SET
} from './types';
import { TBoardUserMetasAction } from 'app/store/model/boardUserMetas/actions/types';

export const boardUserMetasActionSetAction = (
    action: TBoardUserMetasAction
): IBoardUserMetasActionSetAction => {
    return {
        type: USER_BOARD_METAS_ACTION_SET,
        action
    }
};
